import { afiliatedServices } from "./options";

// El backend usa useExtendedTow para decidir entre los productos GRUA y GRUA_EXT
// de la membresia. Si se omite asume false y crea el servicio como GRUA.
export const isExtendedTowProduct = (product) =>
  product?.code === afiliatedServices?.craneExtended;

// Arma el body de POST /services/createTow a partir del producto seleccionado
// del catalogo (/productsCatalog/affiliated)
export const buildCreateTowPayload = (selectedProduct, fields = {}) => {
  const data = { ...fields };
  if (isExtendedTowProduct(selectedProduct)) {
    data.useExtendedTow = true;
  }
  return data;
};
